import DOMPurify from "dompurify";

interface SafeHtmlProps {
  html: string;
}

export const SafeHtml = ({ html }: SafeHtmlProps) => (
  <span dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(html) }} />
);
